import { render, staticRenderFns } from "./link-pagebar.vue?vue&type=template&id=b5f08b5c&"
import script from "./link-pagebar.vue?vue&type=script&lang=js&"
export * from "./link-pagebar.vue?vue&type=script&lang=js&"
import style0 from "./link-pagebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports